const parseValue = (value) => {
	if (Array.isArray(value)) {
		return value.map((item) => parseValue(item))
	}
	if (typeof value === 'object' && value !== null) {
		const result = {}
		// eslint-disable-next-line no-restricted-syntax
		for (const key of Object.keys(value)) {
			result[key] = parseValue(value[key])
		}
		return result
	}
	if (typeof value === 'string' && value[0] === '{') {
		return parseValue(JSON.parse(value))
	}
	return value
}

export const parseInDepth = (jsonString: string) => {
	const jsonObj = JSON.parse(jsonString)
	return parseValue(jsonObj)
}
